import React from 'react'
import classnames from 'classnames'

const renderSection = (part: string, content: any) => {
    if (!content) {
        return ''
    }

    return <div className={'secondary-footer__' + part}>{content}</div>
}

const SecondaryFooter: React.FunctionComponent<{
    isPositionRelative?: boolean
    left?: React.ReactNode
    right?: React.ReactNode
    className?: string
}> = (props) => {
    const containerClassName = classnames('secondary-footer-container', {
        'secondary-footer-container--relative': props.isPositionRelative,
    })
    const footerClassName = classnames('secondary-footer', props.className, {
        'secondary-footer--relative': props.isPositionRelative,
    })

    return (
        <div className={containerClassName}>
            <div className={footerClassName}>
                {renderSection('left', props.left)}
                {renderSection('right', props.right)}
            </div>
            <div className="secondary-footer__shadow" />
        </div>
    )
}

export default SecondaryFooter
